import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Multiselect from '@vueform/multiselect'
import {toRef} from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
  options: Array,
  mode: String,
  label: { type:String, default: "name"},
  selected: [Number, String],
  disabled: Boolean,
  canDeselect: { type: Boolean, default: true},
  canClear: { type: Boolean, default: true},
  searchable: { type: Boolean, default: false},
  valueProp: { type: String, default: "id" }
},
  emits: ['selectChanged'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
let optionsSelected = toRef(props, 'selected');
const options = toRef(props, 'options');

function changeOptions(value) {
  emit('selectChanged', value);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Multiselect), {
      modelValue: _unref(optionsSelected),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(optionsSelected) ? (optionsSelected).value = $event : optionsSelected = $event)),
      mode: __props.mode,
      label: __props.label,
      valueProp: __props.valueProp,
      "close-on-select": true,
      "create-option": false,
      searchable: __props.searchable,
      options: options.value,
      disabled: __props.disabled,
      canDeselect: __props.canDeselect,
      canClear: __props.canClear,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (changeOptions($event)))
    }, null, 8, ["modelValue", "mode", "label", "valueProp", "searchable", "options", "disabled", "canDeselect", "canClear"])
  ]))
}
}

})